/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Fixed_Weekdays_6Inputs */

const en_us2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saturday`)
};

const pt_br2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const es_419_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const pt_pt2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sábado`)
};

const fr_fr2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samedi`)
};

const de_de2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Samstag`)
};

const it_it2_onboarding_fixed_weekdays_6 = /** @type {(inputs: Onboarding_Fixed_Weekdays_6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sabato`)
};

/**
* | output |
* | --- |
* | "Saturday" |
*
* @param {Onboarding_Fixed_Weekdays_6Inputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_fixed_weekdays_6 = /** @type {((inputs?: Onboarding_Fixed_Weekdays_6Inputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Fixed_Weekdays_6Inputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_fixed_weekdays_6(inputs)
	if (locale === "es-419") return es_419_onboarding_fixed_weekdays_6(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_fixed_weekdays_6(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_fixed_weekdays_6(inputs)
	if (locale === "de-DE") return de_de2_onboarding_fixed_weekdays_6(inputs)
	if (locale === "it-IT") return it_it2_onboarding_fixed_weekdays_6(inputs)
	return en_us2_onboarding_fixed_weekdays_6(inputs)
});
export { onboarding_fixed_weekdays_6 as "onboarding.fixed_weekdays.6" }